import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import React from "react";
import { useSnackbar } from "notistack";
import GameAdminSmartCheckIn from "./GameAdminSmartCheckIn";

function GameAdminActions({ gameRef, game, ticketReservations }) {
  const { enqueueSnackbar } = useSnackbar();

  const { visitorsUnknownCount = 0, visitorCount = 0 } = game;

  const addUnknownVisitor = async () => {
    gameRef
      .set(
        {
          visitorsUnknownCount: visitorsUnknownCount + 1,
          visitorCount: visitorCount + 1,
        },
        { merge: true }
      )
      .catch((error) => {
        console.error(error);
        enqueueSnackbar(error.message || error, { variant: "error" });
      });
  };

  const removeVisitor = async () => {
    gameRef
      .set(
        {
          visitorsUnknownCount: visitorsUnknownCount - 1,
          visitorCount: visitorCount - 1,
        },
        { merge: true }
      )
      .catch((error) => {
        console.error(error);
        enqueueSnackbar(error.message || error, { variant: "error" });
      });
  };

  return (
    <>
      <Grid container spacing={3} wrap="nowrap">
        <Grid item xs={6}>
          <Button
            variant="contained"
            size="large"
            color="primary"
            fullWidth
            onClick={addUnknownVisitor}
          >
            Besucher <br />
            kommt
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            fullWidth
            onClick={removeVisitor}
          >
            Besucher <br />
            geht
          </Button>
        </Grid>
      </Grid>
      <Box mt={3} mb={2}>
        <GameAdminSmartCheckIn
          gameRef={gameRef}
          game={game}
          ticketReservations={ticketReservations}
          renderButton={(open) => (
            <Button
              variant="contained"
              size="large"
              color="primary"
              fullWidth
              onClick={() => open(1)}
              style={{ backgroundColor: "#5D5CDE" }}
            >
              Besucher kommt
              <br />
              Ticket Check-In
            </Button>
          )}
          renderSecondButton={(open) => (
            <Box mt={3}>
              <Button
                variant="outlined"
                size="large"
                fullWidth
                onClick={() => open(3)}
                style={{
                  borderColor: "#5D5CDE",
                  color: "#5D5CDE",
                }}
              >
                Liste aller Tickets
              </Button>
            </Box>
          )}
        />
      </Box>

    </>
  );
}

export default GameAdminActions;
